import styled from 'styled-components';
import { DeviceQueries } from './index';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { ContactsSpinnerContainer } from '../ContactsSpinner';

export const ListRowItemWrapper = styled.div`
  height: 60px;
  padding-left: 12px;
  padding-right: 12px;
  
  ${ContactsSpinnerContainer} {
    height: 25px;
  }
`;

export const ListRowItem = styled(Row)`
  font-size: 14px;
  position: relative;
  border-radius: 4px;
  padding-top: 8px;
  padding-bottom: 8px;

  &:hover {
    background-color: #faf8f8;
  }
`;

export const ListRowItemColumn = styled(Col)`
  cursor: pointer;
  display: flex;
  padding: 0 12px;

  @media (${DeviceQueries.mobile}) {
    display: ${({ $hideOnMobile = false }: { $hideOnMobile?: boolean }) => $hideOnMobile ? 'none' : undefined}
  }
`;

export const ListRowItemMultipleFields = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const ListPhone = styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const ListEmail = styled.div`
  font-size: 14px;
  font-weight: 300;
  line-height: 1.43;
  letter-spacing: 0.25px;
  color: #009bdf;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const ListRowItemIcons = styled.div`
  display: none;

  @media (${DeviceQueries.mobile}) {
    display: inline;
  }

  ${ListRowItem}:hover & {
    display: inline
  }
`;

export const EditIcon = styled.img`
  max-width: 32px;
  max-height: 32px;
  cursor: pointer;

  @media (${DeviceQueries.mobile}) {
    max-width: 25px;
    max-height: 25px;
  }
`;

export const DeleteIcon = styled.img`
  max-width: 30px;
  max-height: 30px;
  cursor: pointer;

  @media (${DeviceQueries.mobile}) {
    max-width: 25px;
    max-height: 25px;
  }
`;

export const ListRowItemIconsColumn = styled(Col)`
  display: flex;
  align-items: center;
  justify-content: end;
  padding-right: 5px;
`;

export const ListFullName = styled.div`
  font-size: 14px;
  line-height: 1.5;
  max-height: 42px;
  letter-spacing: 0.44px;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
`;

export const SupplementalInfo = styled.div`
  font-size: 12px;
`;
